import { render } from "./Loader.vue?vue&type=template&id=37b05282"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=37b05282&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script